'use strict';

var Params = function Params(userPref, isExpandedModeEnabled) {
  return function (containerWidth, containerHeight, zoomScaleExtent) {
    var padding = {
      top: isExpandedModeEnabled ? 15 : 25,
      bottom: isExpandedModeEnabled ? 55 : 45
    };
    var yAxisPaddingForLabels = isExpandedModeEnabled ? 90 : 65;
    var yAxisPaddingForOppositeLabels = isExpandedModeEnabled ? 30 : 0;
    if (userPref === 'right-to-left') {
      padding.left = yAxisPaddingForOppositeLabels;
      padding.right = yAxisPaddingForLabels;
    } else {
      padding.left = yAxisPaddingForLabels;
      padding.right = yAxisPaddingForOppositeLabels;
    }
    var width = containerWidth - (padding.left + padding.right);
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      zoomScaleExtent: zoomScaleExtent,
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding,
      xNumberOfTicks: 13,
      yNumberOfTicks: 8,
      yAxisShift: 5,
      xAxisLabelShift: isExpandedModeEnabled ? 45 : 35,
      yAxisLabelShift: 62
    };
  };
};
module.exports = Params;